import type {CreatePaymentMethodBancontactData} from '@stripe/stripe-js';
import {AbstractStripePayment, type ConfirmResult, type TokenResult} from './abstract/class-abstract-stripe-payment';
import {billingDetails} from './stripe';
import {type PeachPayCheckoutData} from '../types';

declare const peachpay_checkout_data: PeachPayCheckoutData;

class StripeBancontactPayment extends AbstractStripePayment {
	public gatewayId() {
		return 'peachpay_stripe_bancontact';
	}

	public async tokenize(): Promise<TokenResult> {
		const billing_details = billingDetails();

		if (peachpay_checkout_data.page.is_order_pay && peachpay_checkout_data.order_pay_details) {
			billing_details.name = peachpay_checkout_data.order_pay_details.billing_first_name + ' ' + peachpay_checkout_data.order_pay_details.billing_last_name;
			billing_details.email = peachpay_checkout_data.order_pay_details.billing_email;
		}

		const {paymentMethod, error} = await this.stripe.createPaymentMethod({
			type: 'bancontact',
			billing_details,
		} as CreatePaymentMethodBancontactData);

		if (error) {
			const message = error.message ?? 'Failed to tokenize payment method.';

			return [null, {
				paymentStatus: 'creationfailed',
				note: message,
			}];
		}

		if (!paymentMethod?.id) {
			return [null, {
				paymentStatus: 'creationfailed',
				note: 'Failed to tokenize payment method.',
			}];
		}

		return [paymentMethod.id, {}];
	}

	public async confirm(clientSecret: string, intermediateURL?: string): Promise<ConfirmResult> {
		const {paymentIntent, error} = await this.stripe.confirmBancontactPayment(clientSecret, {return_url: intermediateURL});

		if (error) {
			const message = error.message ?? 'Failed to confirm payment.';
			return [null, {
				note: message,
			}];
		}

		if (paymentIntent) {
			return ['success', {}];
		}

		return [null, {}];
	}
}

export {StripeBancontactPayment};
